import { bootstrap } from "vue-gtag";

export default {
  methods: {
    cookieReject() {
      try {
        window.uetq = window.uetq || [];
        window.uetq.push("consent", "update", {
          "ad_storage": "denied"
        });
      } catch (e) {
        console.error("Allgemeiner Fehler:", e);
      }
      bootstrap()
        .then((gtag) => {
          this.$gtag.optOut();
        });
    },

    cookieAccept() {
      try {
        window.uetq = window.uetq || [];
        window.uetq.push("consent", "update", {
          "ad_storage": "granted"
        });
      } catch (e) {
        console.error("Allgemeiner Fehler:", e);
      }

      return new Promise((resolve, reject) => {
        try {
          bootstrap()
            .then((gtag) => {
              this.$gtag.optIn();
              this.$gtag.query("consent", "update", {
                ad_storage: "granted",
                analytics_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
                security_storage: "granted",
                personalization_storage: "granted",
                functionality_storage: "granted",
                wait_for_update: 500
              });
              resolve();
            })
            .catch((error) => {
              console.error("Fehler beim Bootstrap:", error);
              reject(error);
            });
        } catch (e) {
          console.error("Allgemeiner Fehler:", e);
          reject(e);
        }
      });

    },


    isAuth() {
      return $("meta[name=auth]").attr("content");
    },

    isSuperAdmin() {
      return false;
    },

    isAdmin() {
      return false;
    },

    // Zeigt die helfen Informationen beim Eingabefeld an.
    showHelpTextField() {
      if (!this.isProduction()) {
        return 1;
      }
      return 0;
    },

    setSentryUser(customer) {
      Sentry.setUser({
        id: customer.id,
        email: customer.email
      });
    }
  }
};
